// NOTE: phoneNumber should contain numbers only, no spaces, no special characters
export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  // Belgium phone number: +32 xxxxxxxxx    -> code(+32) + 9 digits (https://www.mcxess.com/belgian-phone-numbers/)
  const belgiumMobilePhoneRegex = new RegExp("^32[0-9]{9}$");

  // One more format for Belgium mobile phone number
  // Belgium phone number: 04 xxxxxxxx     -> code(04) + 8 digits -> will be transformed to +324xxxxxxxx
  const belgiumShortPhoneRegex = new RegExp("^04[0-9]{8}$");

  // French phone number:  +33 xxxxxxxxx    -> code(+33) + 9 digits (https://www.mcxess.com/french-phone-numbers/)
  const frenchMobilePhoneRegex = new RegExp("^33[0-9]{9}$");

  // Netherlands phone:    +31 xxxxxxxxxx   -> code(+31) + 9 digits
  const netherlandsMobilePhoneRegex = new RegExp("^31[0-9]{9}$");

  return (
    belgiumShortPhoneRegex.test(phoneNumber) ||
    belgiumMobilePhoneRegex.test(phoneNumber) ||
    frenchMobilePhoneRegex.test(phoneNumber) ||
    netherlandsMobilePhoneRegex.test(phoneNumber)
  );
};
